// @module BTM.SearchBoxVisibility.SearchBoxVisibility
define('BTM.SearchBoxVisibility.SearchBoxVisibility.View'
,	[
		'btm_searchboxvisibility_searchboxvisibility.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_searchboxvisibility_searchboxvisibility_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.SearchBoxVisibility.SearchBoxVisibility.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_searchboxvisibility_searchboxvisibility_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/SearchBoxVisibility.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.SearchBoxVisibility.SearchBoxVisibility.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.SearchBoxVisibility.SearchBoxVisibility.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
